import { render, staticRenderFns } from "./line-x.vue?vue&type=template&id=28c44ef2&"
import script from "./line-x.vue?vue&type=script&lang=js&"
export * from "./line-x.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports